import frax from './../components/tool/aid/common/frax'

export default {

	computed: {
		
		theme: function() {

			return {
				form: {
					group: {
						bullets: false
					}
				},
				progress: {
					logo: true
				}
			}

		},

		$isPatient: function() {

			return process.env.VUE_APP_MODE === 'patient'

		},

		isProfiling: function() {

			return !this.$store.getters['session/aid'] && !this.$isPatient

		},

		isAiding: function() {

			return this.$store.getters['session/aid'] || this.$isPatient

		},

		hasAid: function() {

			return this.$store.getters['data/setup'].aid.enabled

		},

		pages: function() {

			return this.$store.getters['pages']

		},

		profile: function() {

			return this.$store.getters['session/profile']

		},

		finished: function() {

			return this.$store.getters['session/finished']

		},

		values: function() {

			return this.$store.getters['session/values']

		},

		sections: function() {

			return this.$store.getters['data/form/sections']

		},

		alerts: function() {

			return this.$store.getters['data/form/alerts']

		},

		blocks: function() {

			return this.$store.getters['data/decision/blocks']

		},

		inputs: function() {

			return this.$store.getters['data/form/inputs']

		},

		currentSection: function() {

			return (this.$store.getters['session/section/current']) ? this.$store.getters['session/section/current'] : false

		},

		currentAlert: function() {

			return (this.$store.getters['session/alerts/current']) ? this.$store.getters['session/alerts/current'] : false

		}

	},

	methods: {

		createInput: function(params) {

			var config = {
				id: 0,
				variable: 0,
				info: 0,
				type: 0,
				name: '',
				default: {
					enabled: 0,
					value: null,
					logic: {}
				},
				layout: {
					stacked: 0
				},
				required: {
					enabled: this.$constants.required.always,
					logic: {}
				},
				visibility: {
					enabled: this.$constants.visibility.required,
					logic: 0
				},
				multiple: {
					enabled: 0
				},
				locked: {
					enabled: 0
				},
				automated: {
					enabled: 0
				},
				text: {
					label: '',
					summary: '',
					missing: ''
				},
				track: { 
					enabled: 0,
					context: 0
				},
				options: []
			}

			config = this.$_.extend({}, config, params)

			return config

		},

		frax: function(type) {

			if (this.$isPatient && this.$store.getters['session/patient/mode'] === 'generic') return 0

			var score = this.$getValue((type === 'major') ? 'system.1a' : 'system.1b')

			if (score === null) {

				var age = this.$store.getters['logic/variable'](6)

				// Without a valid age in the lookup table there is no FRAX to
				// compute (guards against missing/out-of-range age crashing the
				// table lookup below).
				if (!age || !frax[age]) return 0

				var sex = this.$store.getters['logic/variable'](5)
				var steroids = this.$store.getters['logic/variable'](7)
				var osteoproticA = this.$store.getters['logic/variable'](13)
				var osteoproticB = this.$store.getters['logic/variable'](19) === 3
				var osteoproticC = this.$store.getters['logic/variable'](12) <= -2.5

				var reference = 'a'

				if (steroids) reference += 's'
				if (osteoproticA || osteoproticB || osteoproticC) reference += 'o'

				sex = (sex == 1) ? 'm' : 'f'
				type = (type === 'major') ? 'm' : 'h'

				score = frax[age][reference][type][sex] || frax[age]['a'][type][sex]

			}

			return parseFloat(score)

		},

		evaluate: function(logic) {

			return this.$store.getters['logic/evaluate'](logic)

		},

		required: function(item, field) {

			return this.$store.getters['logic/required'](item, field)

		},

		visible: function(item, field) {

			return this.$store.getters['logic/visible'](item, field)

		},

		$getValue: function(name) {

			if (this.$isPatient && this.$store.getters['session/patient/mode'] === 'generic') return false

			var id = this.$store.getters['logic/variable/named'][name]

			if (id === undefined) return null

			return this.$store.getters['logic/variable'](id)

		}

	}

}